import * as React from "react";

import {
	createNativeStackNavigator,
	NativeStackScreenProps,
} from "@react-navigation/native-stack";
import OnBoarding from "./OnBoarding";

import SplashScreen from "./SplashScreen";
import AuthStack from "./AuthStack";
import NewUserStack from "./NewUserStack";
import PolicyPageWebView from "./PolicyPageWebView";

export type BoardingStackNavParamList = {
	OnBoarding: undefined;
	AuthStack: any;
	SplashScreen: undefined;
	NewUserStack: any;
	PolicyPageWebView: undefined;
	SignIn: undefined;
};
export type OnBoardingScreenProps = NativeStackScreenProps<
	BoardingStackNavParamList,
	"OnBoarding"
>;

export type SplashScreenProps = NativeStackScreenProps<
	BoardingStackNavParamList,
	"SplashScreen"
>;

export type PolicyPageWebViewProps = NativeStackScreenProps<
	BoardingStackNavParamList,
	"PolicyPageWebView"
>;

const BoardingStackNav =
	createNativeStackNavigator<BoardingStackNavParamList>();

const BoardingStack = () => {
	const [firstLoad, setFirstLoad] = React.useState(true);
	React.useEffect(() => {
		setTimeout(() => {
			setFirstLoad(false);
		}, 2500);
	}, []);
	return (
		<BoardingStackNav.Navigator
			initialRouteName="SplashScreen"
			screenOptions={{ headerShown: false }}
		>
			{firstLoad && (
				<BoardingStackNav.Screen name="SplashScreen" component={SplashScreen} />
			)}
			<BoardingStackNav.Screen name="OnBoarding" component={OnBoarding} />
			<BoardingStackNav.Screen name="AuthStack" component={AuthStack} />
			<BoardingStackNav.Screen name="NewUserStack" component={NewUserStack} />
			<BoardingStackNav.Screen
				name="PolicyPageWebView"
				component={PolicyPageWebView}
			/>
		</BoardingStackNav.Navigator>
	);
};

export default BoardingStack;
